import React from "react";

import "./ProgressBar.scss";

interface ProgressBarType {
  progress: number;
  withText?: boolean;
  outerClass?: string;
  innerClass?: string;
}

export default function ProgressBar(props: ProgressBarType) {
  const { progress, withText, outerClass, innerClass } = { ...props };

  return (
    <div className={`${outerClass || "progress-bar-container"}`}>
      <div className={`${innerClass || "progress-bar"}`} style={{ width: `${progress}%` }}>
        {withText && <span className="progress-bar-value">{`${progress}%`}</span>}
      </div>
    </div>
  );
};
